import React, { useRef } from 'react';

const ReelContainer = ({ children }) => {
    const containerRef = useRef(null);
    const timeoutRef = useRef(null);

    const handleScroll = () => {
        const container = containerRef.current;
        if (!container) return;

        // Apply motion blur effect
        // We use a check to avoid unnecessary DOM writes, though classList is efficient
        if (!container.classList.contains('blur-sm')) {
             container.classList.add('blur-sm', 'scale-[0.98]', 'brightness-90');
        }

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            if (container) {
                container.classList.remove('blur-sm', 'scale-[0.98]', 'brightness-90');
            }
        }, 100);
    };

    return (
        <div 
            ref={containerRef}
            onScroll={handleScroll}
            className="reels-viewer transition-all duration-300 ease-out transform-gpu" 
            style={{ 
                height: '100%', 
                overflowY: 'auto', 
                scrollSnapType: 'y mandatory' 
            }}
        >
            {children}
        </div>
    );
};

export default ReelContainer;